<script setup lang="ts">
import GwTooltipNew from '@/components/lib/GwTooltip/GwTooltipNew.vue'
import GwBtn from '@/components/lib/GwBtn/GwBtn.vue'
import { t } from '@/locales/i18n'
import { usePaymentPlan } from '@/composables/paymentPlan'

const { cryptoPaymentEnabled, cryptoSubscriptionActive, multiplePaymentMethods } = usePaymentPlan()

interface CheckoutControlsProps {
  downgrading: boolean
  newCardLoading: boolean
  checkoutLoading: boolean
}

defineProps<CheckoutControlsProps>()

const emit = defineEmits(['select-payment-method', 'checkout', 'checkout-with-crypto'])
</script>

<template>
  <div class="d-flex ga-2 justify-end ml-auto flex-wrap">
    <GwBtn
      v-if="!downgrading"
      variant="btn_large"
      class="ml-auto"
      data-tst="btn_change"
      :loading="newCardLoading"
      @click.stop="$emit('select-payment-method')"
      >{{
        $t(`payment.btns.${multiplePaymentMethods ? 'change_payment_method' : 'change_card'}`)
      }}</GwBtn
    >
    <GwBtn
      v-if="downgrading"
      variant="btn_primary-v2-large"
      loadingVariant="spinner"
      class="ml-auto"
      style="--app-clr-primary-v2: var(--app-clr-primary); --text-clr: var(--clr-white-0)"
      data-tst="btn_checkout"
      :loading="checkoutLoading"
      :text="$t('btn.continue')"
      @click.stop="emit('checkout')"
    />
    <GwTooltipNew
      v-else
      :tooltip="
        cryptoSubscriptionActive && cryptoPaymentEnabled
          ? t('payment.tooltips.checkout_with_crypto')
          : t('payment.tooltips.pay_with_saved_card')
      "
      placement="top"
      variant="transparent"
    >
      <template #opener="{ listeners }">
        <GwBtn
          variant="btn_primary-v2-large"
          loadingVariant="spinner"
          class="ml-auto"
          style="
            --app-clr-primary-v2: var(--app-clr-primary);
            --text-clr: var(--clr-white-0);
            padding: 1.25rem 2rem;
          "
          data-tst="btn_checkout"
          :loading="checkoutLoading"
          :text="$t('payment.btns.checkout')"
          @click.stop="
            !cryptoSubscriptionActive
              ? emit('checkout')
              : cryptoPaymentEnabled
                ? emit('checkout-with-crypto')
                : emit('select-payment-method')
          "
          v-on="listeners"
        />
      </template>
    </GwTooltipNew>
  </div>
</template>
